module.exports = __webpack_public_path__ + "static/media/GM.9c55d78f.png";